import { call, select } from "redux-saga/effects";
import { getDisagregateProduct as getDisagregateProductBit } from "../bitSagas/disagregateProduct";
import { actions as apisNeedsActions } from "../reducers/apisNeeds";

const offerStore = (state) => state.offer;

export function* getDisagregateProduct(params) {
  const { normalizeHttpErrors, showError } = params;

  const offerInfo = yield select(offerStore);
  const {
    allPOsToBuy,
    netflixObj,
    poR,
    storageId,
    colorId,
  } = offerInfo;
  let poN;
  let netflixPlan;
  if (netflixObj && netflixObj.productOffering && netflixObj.mode) {
    poN = netflixObj.productOffering;
    netflixPlan = netflixObj.mode;
  }
  const getDisagregateProductParams = {
    allPOsToBuy,
    poN,
    netflixPlan,
    poR,
    storageId,
    colorId,
    reduxUpdate: {
      successUpdate: apisNeedsActions.setDisagregateProduct,
      errorUpdate: showError,
    },
    normalizeHttpErrors,
  };
  yield call(getDisagregateProductBit, getDisagregateProductParams);
  return null;
}
